var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.profile.title ||
    _vm.profile.image_url ||
    _vm.profile.name ||
    _vm.profile.email
    ? _c("div", { staticClass: "mb-8" }, [
        _vm.profile.title
          ? _c(
              "h2",
              {
                staticClass: "text-h6 text--text mt-0",
                class: _setup.isMobile ? "mb-4" : "mb-3",
                attrs: { "data-qa": "ceo-contact-title" },
              },
              [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _setup.transDynamic(
                        _vm.profile,
                        `title,${_setup.language},${_setup.needTranslate}`
                      )
                    ) +
                    "\n  "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "d-flex align-center mb-3",
            class: _setup.isMobile ? "mb-4" : "mb-3",
          },
          [
            _vm.profile.image_url
              ? _c("img", {
                  staticClass: "mr-3",
                  attrs: {
                    "data-qa": "ceo-contact-image",
                    src: _vm.profile.image_url,
                    alt: _setup.transDynamic(
                      _vm.profile,
                      `name,${_setup.language},${_setup.needTranslate}`
                    ),
                    width: "40",
                    height: "40",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm.profile.name
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-1 text--text",
                      attrs: { "data-qa": "ceo-contact-name" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.transDynamic(
                              _vm.profile,
                              `name,${_setup.language},${_setup.needTranslate}`
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.profile.email
                ? _c(
                    "a",
                    {
                      staticClass:
                        "text-body-1 d-inline-flex link-decoration-none primary--text",
                      attrs: {
                        "data-qa": "ceo-contact-email",
                        href: `mailto:${_vm.profile.email}`,
                      },
                    },
                    [_vm._v(_vm._s(_vm.profile.email))]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }